module.exports = __webpack_public_path__ + "static/media/Main_Logo.b9e0154b.png";